import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Disc, FileVideo } from 'lucide-react';
import { FaTiktok } from "react-icons/fa";

const DownloadManager = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#12141D] to-[#151823] relative overflow-hidden">
      <div className="absolute top-1/2 -translate-y-1/2 left-1/4 w-[500px] h-[500px] bg-[#00E5FF] rounded-full blur-[300px] opacity-10" />
      
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1C2538]/40 border border-[#2A3547] backdrop-blur-sm">
              <span className="text-[#00E5FF] text-sm font-medium tracking-wider uppercase flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-[#00E5FF]">
                  <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Your Private Collection Vault
              </span>
            </div>
            
            <h2 className="text-4xl font-bold text-white mt-4 mb-6">
              Manage All Your Downloads
            </h2>
            <p className="text-gray-400 mb-8">
              Keep track of your TikTok collections with our intuitive dashboard. Monitor progress, manage space, and download when ready.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <Disc className="w-5 h-5 text-[#00E5FF] mt-1" />
                <p className="text-gray-300">Track download progress for multiple collections at once</p>
              </div>
              <div className="flex items-start gap-3">
                <Disc className="w-5 h-5 text-[#00E5FF] mt-1" />
                <p className="text-gray-300">Get notifications when your downloads are ready</p>
              </div>
              <div className="flex items-start gap-3">
                <Disc className="w-5 h-5 text-[#00E5FF] mt-1" />
                <p className="text-gray-300">Download entire collections with a single click</p>
              </div>
            </div>

            
          </div>

          <Card className="bg-gradient-to-br from-[#1A2942] to-[#1E1E2E] border-none rounded-3xl p-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <FileVideo className="w-6 h-6 text-[#00E5FF]" />
                <h3 className="text-xl font-semibold text-white">Your Download History</h3>
              </div>
            </div>

            <div className="space-y-4">
              {[{
              name: "Dance Tutorials",
              count: 45,
              size: "234 MB",
              status: "Complete"
            }, {
              name: "Cooking Tips",
              count: 28,
              size: "156 MB",
              status: "Processing"
            }, {
              name: "Travel Vlogs",
              count: 12,
              size: "89 MB",
              status: "Queued"
            }].map(collection => <div key={collection.name} className="bg-[#111520] rounded-xl p-4 hover:bg-[#161A27] transition-colors">
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-3">
                      <FaTiktok className="w-4 h-4 text-gray-400" />
                      <span className="text-white font-medium">{collection.name}</span>
                    </div>
                    <span className="text-[#00E5FF]">{collection.status}</span>
                  </div>
                  <div className="flex justify-between text-sm text-gray-400">
                    <span>{collection.count} videos</span>
                    <span>{collection.size}</span>
                  </div>
                </div>)}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default DownloadManager;
